import type { Styles } from 'common/types';

export const styles: Styles = {
  /* No image: fill full width, taller */
  uploaderWrapper: {
    '& > *': {
      borderRadius: '0 0 8px 8px !important',
      border: 'none !important',
      height: '220px !important',
    },
  },

  /* Has image: edge-to-edge */
  contentRow: {
    display: 'flex',
    alignItems: 'stretch',
  },

  imageContainer: {
    position: 'relative',
    flexShrink: 0,
    width: { xs: '100%', md: '40%' },
    minHeight: '280px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  imageElement: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },

  deleteButton: {
    position: 'absolute',
    top: 10,
    right: 10,
    backgroundColor: 'rgba(255,255,255,0.9)',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    '&:hover': {
      backgroundColor: 'error.main',
      color: '#fff',
    },
  },

  textContainer: {
    flex: 1,
    p: { xs: 2.5, md: 3 },
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },

  noTextState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1.5,
    flex: 1,
    minHeight: '200px',
    color: 'text.disabled',
  },

  textPreview: {
    fontSize: '0.875rem',
    lineHeight: 1.7,
    color: 'text.primary',
    '& h1, & h2, & h3': { mt: 0 },
    '& p': { mt: 0, mb: 1 },
    '& ul, & ol': { pl: 2.5 },
  },
};
